module.exports = __webpack_public_path__ + "img/bullet.ad2e1db1.png";